import Vue from 'vue';
import axios from 'axios';
import store from "./vuex/store";
import VueAxios from 'vue-axios';
import Mixin from "./mixins/GlobalMixins";
import VueVideoPlayer from 'vue-video-player';
import linkify from 'vue-linkify'
Vue.directive('linkified', linkify);
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Icon } from "leaflet";
import 'leaflet/dist/leaflet.css';
import VueAudio from 'vue-audio-better'
import App from './components/App.vue';
import widgetChatApp from './components/widgetChatApp.vue';
import GuppyChatButtonApp from './components/GuppyChatButtonApp.vue';
import jQuery from 'jquery';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css'
Vue.use(VueCroppie);

import RuntimeTemplateCompiler from "vue-runtime-template-compiler"
Vue.use(RuntimeTemplateCompiler)
require("leaflet-fullscreen/dist/leaflet.fullscreen.css");
require("leaflet-fullscreen/dist/Leaflet.fullscreen");
Vue.use(VueAudio)
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("@/resources/marker.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

axios.defaults.baseURL = window.wpguppy_scripts_vars.restapiurl;
axios.defaults.headers.common['Authorization'] = `Bearer ` + window.wpguppy_scripts_vars.authToken;
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.use(VueVideoPlayer);

import { videoPlayer } from 'vue-video-player';
Vue.component('video-player', videoPlayer);
Vue.use(VueAxios, axios);
Vue.config.productionTip = true;
Vue.mixin(Mixin); 
// messanger chat
if( jQuery('#wpguppy-messanger-chat').length && window.wpguppy_scripts_vars.userId ) {
  new Vue({
    store,
    render: h => h(App),
  }).$mount('#wpguppy-messanger-chat')
}else if( jQuery('#wpguppy-widget-chat').length) {
  new Vue({
    store,
    render: h => h(widgetChatApp),
  }).$mount('#wpguppy-widget-chat')
}
//woocommerce product chat button
if( jQuery('#wpguppy-woo-products').length && window.wpguppy_scripts_vars.userId ) {
  Vue.component('wpguppy-woo-chat-button', GuppyChatButtonApp)
  new Vue({
    store,
  }).$mount('#wpguppy-woo-products');
}
